import * as React from 'react';
import {TextBuildingBlock} from '../../types/Report';

export default function PreviewTextBlock({buildingBlock}: {buildingBlock: TextBuildingBlock}) {
    return (
        <div
            style={{
                fontSize: buildingBlock.textStyle.fontSize + 5,
                fontWeight: buildingBlock.textStyle.bold ? 'bold' : 'normal',
                fontStyle: buildingBlock.textStyle.italic ? 'italic' : 'normal',
                textDecoration: buildingBlock.textStyle.underlined ? 'underline' : 'none',
            }}>
            {buildingBlock.text}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheetBlocks/PreviewTextBlock.tsx